import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { EASE_OUT } from '../../utils/motion';
type ParallaxFrameProps = {
  children: React.ReactNode;
  className?: string;
  distance?: number;
};
export function ParallaxFrame({
  children,
  className = '',
  distance = 40
}: ParallaxFrameProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [distance, -distance]);
  return <div ref={ref} className={className} data-id="element-257" data-mp="2cn8wnr4uocg0">
      <motion.div style={{
      y
    }} data-id="element-258" data-mp="2ho6fm5xopaik">
        <motion.div initial={{
        opacity: 0,
        y: 24,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT
      }} data-id="element-259" data-mp="2hmvaa1olbupc">
          {children}
        </motion.div>
      </motion.div>
    </div>;
}